import * as  TYPE from "./actionTypes"

const initialState = {
  commons: '',
  tournaments: '',
  vendors: ''
}

const Common = (state = initialState, action) => {
  switch (action.type) {
    case TYPE.COMMON:
      state = {
        commons: action.commons,
        tournaments: action.tournaments,
        vendors: action.vendors
      }
      break
    
    default:
      state = state
      break
  }
  return state
}

export default Common
